import { FooterType, AppShellDataType, Action } from 'Shared/State';

export default function(state: FooterType = null, action: Action, appShellData: AppShellDataType): FooterType {
  return appShellData.footer;
}
